import { safeApiRequest } from './apiClient';
import { sanitizeSearchInput } from '../utils/security';

const FAULT_RECORDS_ENDPOINT = '/api/fault-records';

/**
 * Arıza kategorilerini ve arıza kayıtlarını tree view olarak getir
 */
export const fetchFaultRecordsTree = async (kategoriId = null) => {
  const queryParams = {};
  if (kategoriId) {
    queryParams.kategoriId = kategoriId;
  }
  
  return safeApiRequest(`${FAULT_RECORDS_ENDPOINT}/tree`, {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};

/**
 * Arıza kayıtlarını ara
 */
export const searchFaultRecords = async (arama, { kategoriId, limit = 20 } = {}) => {
  if (!arama || arama.trim().length < 3) {
    throw new Error('Arama terimi en az 3 karakter olmalıdır');
  }
  
  const queryParams = {
    arama: sanitizeSearchInput(arama),
    limit: Math.min(limit, 50),
  };
  
  if (kategoriId) {
    queryParams.kategoriId = kategoriId;
  }
  
  return safeApiRequest(`${FAULT_RECORDS_ENDPOINT}/search`, {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};

/**
 * Arıza kayıtlarını listele
 */
export const fetchFaultRecords = async ({ 
  page = 1, 
  limit = 50, 
  kategoriId,
  aktif = true 
} = {}) => {
  const queryParams = {
    sayfa: page,
    limit: limit,
  };
  
  if (kategoriId) {
    queryParams.kategoriId = kategoriId;
  }
  
  if (aktif === false) {
    queryParams.aktif = 'false';
  }
  
  return safeApiRequest(FAULT_RECORDS_ENDPOINT, {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};

/**
 * ID listesi ile arıza kayıtlarını getir (taslak restore için)
 */
export const fetchFaultRecordsByIds = async (ids = []) => {
  const idList = (Array.isArray(ids) ? ids : [])
    .map((id) => String(id?.id || id?._id || id || '').trim())
    .filter((id) => /^[a-f0-9]{24}$/i.test(id));
  if (idList.length === 0) {
    return { basarili: true, veri: { arizaKayitlari: [] } };
  }
  return safeApiRequest(`${FAULT_RECORDS_ENDPOINT}/by-ids`, {
    method: 'GET',
    query: { ids: idList.join(',') },
    skipCsrf: true,
  });
};

